













































































import { Component, Vue } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { AlterarSenhaModel } from "@/models/login/AlterarSenhaModel";
import usuarioModule from "@/store/usuario/UsuarioModule";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class AlterarSenha extends Vue {
  senha: AlterarSenhaModel = {} as AlterarSenhaModel;
  mensagemModal = false;
  mensagem = "";
  sucesso = false;
  loading = false;

  alterarSenha() {
    this.mensagemModal = false;
    this.mensagem = "";
    this.sucesso = false;
    this.loading = true;

    usuarioModule
      .alterarSenha(this.senha)
      .then(() => {
        this.mensagem = "Alteração de senha efetuado com sucesso.";
        this.sucesso = true;
      })
      .catch((err: any) => {
        console.log(err);
        this.mensagem = err.message;
      })
      .finally(() => {
        this.mensagemModal = true;
        this.loading = false;
      });
  }

  fecharModal() {
    if (this.sucesso) {
      this.$router.push({ name: "HomePage" });
    }
    this.mensagemModal = false;
  }
}
